/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:e848b50f-c9d0-4822-9cf9-e61e1e74aff2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_b4cPDbIqw",
    "aws_user_pools_web_client_id": "6q8esvd53968pemeis013l4n0e",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://cxll3bw3fjh2japxn7sr5duwze.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
